export default {
  'label.tab.download_label': '下載運單',
  'label.tab.download_label.tooltip': '下載運單',
  'label.tab.pending_label': '待生成運單',
  'label.tab.pending_label.tooltip': '待生成運單',
  'label.tab.rejected_label': '生成失敗運單',
  'label.tab.rejected_label.tooltip': '運單生成失敗，查看並重新編輯',
  'label.tab.dispatched_wms': '已發貨 (WMS)',
  'label.tab.dispatched_wms.tooltip': '訂單已經出庫',
  'label.tab.in_progress_wms': '處理中 (WMS)',
  'label.tab.in_progress_wms.tooltip': '已經發送到倉庫，等待倉庫操作出倉',
  'label.tab.send_delivery_order': '待發送到 - WMS',
  'label.tab.send_delivery_order.tooltip': '選擇生成的運單,發送到指定的倉庫進行出庫',
  'label.document-number': 'Doc No.',
  'label.pending.new': '創建簡單的運單',
  'label.pending.upload': '上傳Excel創建運單',
  'label.create.title': '創建簡單的運單',
  'label.create.title_content': '請提供運單詳情',
  'label.create_multi.title': '上傳Excel批量創建運單',
  'label.create_multi.title_content': '請上傳運單詳情',
  'label.create.basic-info': '運單基本信息',
  'label.create.receiver-info': '收件人資訊',
  'label.create.declared-info': '申報訊息',
  'label.create.item.title': '新增申報物品',
  'label.edit.item.title': '編輯申報項目',
  'label.id': 'ID',
  'label.courier': '快遞',
  'label.wms_merchant': '貨主',
  'label.wms_warehouse': '倉庫',
  'label.wms_warehouse_code': '倉庫代碼',
  'label.wms_merchant_code': '貨主代碼',
  'label.wms_delivery_note_code': 'DN 號',
  'label.wms_preorder.delete-confirm': '確定刪除此訂單嗎？ ',
  'label.cancel-wms-preorder': '刪除Pre Order',
  'label.service_name': '服務名稱',
  'label.service_type': '服務類型',
  'label.self_pick_location_code': '自提（商店/儲物櫃）',
  'label.sr_direct_line': 'SR Direct Line',
  'label.sr_tracking_no': 'SR 追蹤編號',
  'label.reference_no': '參考編號',
  'label.vat_number': 'VAT 編號',
  'label.ioss_number': 'IOSS 編號',
  'label.eori_number': 'EORI 編號',
  'label.po_number': 'PO單號',
  'label.invoice_number': '發票號碼',
  'label.department_reference': '部門參考號碼',
  'label.duty_third_party_account': 'D/T: O',
  'label.address_book': '已儲存的位址',
  'label.company': '公司',
  'label.email': '電子郵件',
  'label.shipment_content': '商品描述',
  'label.delivery_name': '配送名稱',
  'label.all_address': '地址',
  'label.address': '地址行1',
  'label.address1': '地址行2',
  'label.address2': '地址行3',
  'label.country': '國家',
  'label.district': '區域',
  'label.city': '城市',
  'label.state': '州',
  'label.postal': '郵遞區號',
  'label.phone': '電話',
  'label.create.shipper-info': '寄件人資訊',
  'label.shipper_name': '寄件人名稱',
  'label.shipper_company': '托運公司',
  'label.shipper_email': '寄件人電子郵件',
  'label.shipper_address': '寄件人地址行1',
  'label.shipper_address1': '寄件人地址行2',
  'label.shipper_address2': '寄件人地址行3',
  'label.shipper_country': '寄件人國家',
  'label.shipper_district': '寄件人區​​',
  'label.shipper_city': '寄件人城市',
  'label.shipper_state': '寄件人州',
  'label.shipper_postal': '寄件人郵遞區號',
  'label.shipper_phone': '寄件人電話',
  'label.shipper_all_address': '寄件人地址',
  'label.battery': '電池',
  'label.product_type': '包裝類型',
  'label.package_num': '包裝號',
  'label.courier_reference_id': '快遞參考 ID',
  'label.incoterm': 'Incoterm',
  'label.declared_value': '申報價值',
  'label.box': '箱',
  'label.message.box': '箱',
  'label.create.package-title': '輸入您的包裹資訊',
  'label.package-info': '包裝資訊',
  'label.declared_currency': '申報貨幣',
  'label.insurance': '保險',
  'label.package_no': '包裝編號',
  'label.insurance_value': '保險價值',
  'label.insurance_currency': '保險貨幣',
  'label.product_code': '產品代碼',
  'label.weight': '重量',
  'label.weight_unit': '重量單位',
  'label.height': '高度',
  'label.width': '寬度',
  'label.dimension_uom': '尺寸單位',
  'label.length': '長度',
  'label.remark': '備註',
  'label.warehouse_remark': 'WH 備註',
  'label.sku': 'SKU',
  'label.sku_asn': 'SKU/ASN',
  'label.product_name': '產品名稱',
  'label.request_asn_code': '請求 ASN / RMA',
  'label.battery_type': '電池',
  'label.product_weight': '產品重量',
  'label.description_export': '英文產品名稱',
  'label.description_import': '中文產品名稱',
  'label.country_of_origin': '原產地',
  'label.quantity': '數量',
  'label.request_qty': '請求數',
  'label.item_declared_value': '申報價值（每件）',
  'label.hscode': 'HsCode',
  'label.hsdescription': 'HsDescription',
  'label.estimated-volume': '估計體積',
  'label.action': '操作',
  'label.upload.title': 'Upload To Create Multi Shipments',
  'label.upload.title_content': '請提供Shipment詳情',
  'label.batch_request_id': '批次 ID',
  'label.batch_request_number': '批次編號',
  'label.waybill_number': 'Waybill編號',
  'label.barcode': '條碼',
  'label.tracking_no': '追蹤號碼',
  'label.return_tracking_no': '退貨追蹤號碼',
  'label.ship_date': 'Ship Date',
  'label.upload_date': '上傳日期',
  'label.pending.title': '待處理運單',
  'label.rejected.title': '生成失敗運單',
  'label.to-download.title': '下載運單',
  'label.wms-shipped.title': '已發貨 (WMS)',
  'label.wms-in-progress.title': '進行中 (WMS)',
  'label.wms-preorder.title': '待發送訂單 - WMS',
  'label.pieces': '件',
  'label.search': '搜尋',
  'label.from_date': '建立自',
  'label.to_date': '建立至',
  'label.reset': '重置',
  'label.view': '查看',
  'label.edit': '編輯',
  'label.edit.title': '編輯運單資料',
  'label.collapse': '折疊',
  'label.system_status': 'LME系統狀態',
  'label.status': '狀態',
  'label.api_failed_message': '失敗訊息',
  'label.print_label': '列印運單',
  'label.pick_up': '已拾取',
  'label.batch_print': '批次列印',
  'label.batch_download': '批次摘要',
  'label.download_max_tooltips': '系統最多只能支援下載2000條',
  'label.button.download_delivery_summary': '下載摘要',
  'label.confirm.download_delivery_summary': '您確定要根據您的過濾器參數下載Shipment摘要嗎？ ',
  'label.button.download_shipment_trace': '下載追蹤',
  'label.confirm.download_shipment_trace': '您確定要透過您的過濾器參數下載Shipment追蹤摘要嗎？ ',
  'label.batch_print_waybill': 'Waybill (批次)',
  'label.batch_print_invoice': '發票 (批次)',
  'label.download_pdf': '下載 PDF',
  'label.upload-to-download': '選擇下載',
  'label.upload-to-download-waybill': '下載運單（按上傳 Excel) ',
  'label.upload-to-download-invoice': '下載發票（按上傳 Excel）',
  'label.upload_to_download.waybill-title': '選取的下載運單',
  'label.batch_to_download.waybill-title': '批次列印運單',
  'label.upload_to_download.invoice-title': '選取的下載發票',
  'label.batch_to_download.invoice-title': '大量列印發票',
  'label.batch_to_download.excel': '批次下載Excel',
  'label.to_download.batch_number': '批次下載',
  'label.message.batch_number': '請選擇批次',
  'label.download_order': '下載訂單',
  'label.more_action': '更多操作',
  'label.delete': '刪除',
  'label.delete-confirm': '您確定要刪除嗎？ ',
  'label.updated_at': '更新時間',
  'label.captcha.second': '秒',
  'label.可選': '（可選）',
  'label.submit': '提交',
  'label.cancel': '取消',
  'label.complete': '完成',
  'label.save': '儲存',
  'label.email.placeholder': '電子郵件',
  'label.password.placeholder': '密碼',
  'label.confirm-password.placeholder': '確認密碼',
  'label.phone-number.placeholder': '電話號碼',
  'label.verification-code.placeholder': '驗證碼',
  'label.title.label': '標題',
  'label.title.placeholder': '為目標命名',
  'label.date.label': '開始與結束日期',
  'label.date.placeholder.start': '開始日期',
  'label.date.placeholder.end': '結束日期',
  'label.create-item.create': '新增項目',
  'label.create.submit': '提交',
  'label.edit.update': '更新',
  'label.shipping_method': 'Shipping方式',
  'label.message.courier': '請選擇快遞',
  'label.message.service_name': '請選擇服務名稱',
  'label.message.service_type': '請選擇服務類型',
  'label.message.self_pick_location_code': '請選擇自提（商店/儲物櫃）',
  'label.message.shipping_code': '請選擇運送方式',
  'label.message.shipment_content': '請輸入商品描述',
  'label.message.reference_no': '請輸入參考號碼',
  'label.message.product_type': '請輸入包裹類型',
  'label.message.package_num': '請輸入包號',
  'label.message.delivery_name': '請輸入投遞名稱',
  'label.message.address_book': '選擇您已儲存的地址',
  'label.message.company': '請輸入公司',
  'label.message.email': '請輸入電郵',
  'label.message.email_format': '輸入的電子郵件無效!',
  'label.message.phone': '請輸入電話號碼',
  'label.message.country': '請輸入國家',
  'label.message.city': '請輸入城市',
  'label.message.postal': '請輸入郵寄地址',
  'label.message.address': '請輸入地址行1',
  'label.message.address1': '請輸入地址行2',
  'label.message.address2': '請輸入地址行3',
  'label.message.shipper_name': '請輸入寄件人姓名',
  'label.message.shipper_email': '請輸入寄件人電郵',
  'label.message.shipper_phone': '請輸入寄件人電話號碼',
  'label.message.shipper_country': '請輸入寄件人國家',
  'label.message.shipper_city': '請輸入寄件人城市',
  'label.message.shipper_postal': '請輸入寄件人郵遞區號',
  'label.message.shipper_address': '請輸入寄件人地址1行1',
  'label.message.shipper_address1': '請輸入寄件人地址行2',
  'label.message.shipper_address2': '請輸入寄件人地址行3',
  'label.message.declared_value': '請輸申報價值',
  'label.message.currency': '請選貨幣',
  'label.message.battery_type': '請選擇電池',
  'label.message.incoterm': '請選擇 Incoterm',
  'label.message.sku': '請輸入SKU',
  'label.message.product_name': '請輸入產品名稱',
  'label.message.description_export': '請輸入導出描述',
  'label.message.description_import': '請輸入導入描述',
  'label.message.country_of_origin': '請輸入來源地',
  'label.message.quantity': '請輸入數量',
  'label.message.weight': '請輸入重量',
  'label.message.item_declared_value': '請輸入申報價值',
  'label.message.product_weight': '請輸入產品重量',
  'label.detail.title': '運單資料',
  'label.detail.item.title': '運單項目',
  'label.status.cancel': 'Cancel',
  'label.status.valid_in_progress': 'Valid In Progress',
  'label.status.pending_valid': 'Pending Valid',
  'label.status.valid_success': 'Valid Success',
  'label.status.valid_failed': 'Valid Failed',
  'label.status.created_failed': 'Created Failed',
  'label.status.resave_label': 'ReSave Label',
  'label.status.created_success': 'Created Success',
  'label.status.requested': 'Requested',
  'label.status.pick_up': 'Picked Up',
  'label.status.audit': 'Audit',
  'label.status.not_audit': 'Not Audit',
  'label.status.inbound': 'Inbound',
  'label.status.outbound': 'Outbound',
  'label.status.frozen': 'Frozen',
  'label.status.exception': 'Exception',
  'label.status.in_progress': 'In Progress',
  'label.status.not_known': 'Not Known',
  'label.status.not_exit': 'Not Exit',
  'label.status.transporting': 'Transporting',
  'label.status.submited': 'Submited',
  'label.status.collect': 'Collect',
  'label.status.deleted': 'Deleted',
  'label.status.refunded': 'Refunded',
  'label.status.pending_transfer': 'Pending transfer',
  'label.status.refund_in_warehouse': 'Refund in warehouse',
  'label.status.signed': 'Signed',
  'label.button.download': '下載',
  'label.button.download-invoice': '發票',
  'label.shipper_account': '寄件人帳戶',
  'label.print_selected_label': '列印已選的運單',
  'label.print_selected_invoices': '列印已選的發票',
  'label.print_selected_reference': '列印已選的參考',
  'shipping.title.route': '追蹤狀態',
  'shipping.tracking': '追蹤',
  'shipping.tracking_number': '追蹤號碼',
  'shipping.search_placeholder': '輸入要查詢的追蹤號碼',
  'shipping.audited': 'Audited',
  'shipping.collect': 'Collect',
  'shipping.out_warehouse': 'Out Warehouse',
  'shipping.transporting': 'Transporting',
  'shipping.signing': 'Signing',
  'shipping.signed': 'Signed',
  'shipping.message.duplicate': '追蹤號碼錯誤，請檢查。 ',
  'shipping.message.retry_later': '請稍後重試。 ',
  'shipping.message.add_tracking_number': '請新增追蹤號碼。 ',
  'label.amount': '金額',
  'label.lated_inventories': '參考編號 {delivery_order_no} 可用庫存',
  'label.create_return_label.title': '建立參考號碼為{reference_no} 的退回運單',
  'label.error.colon': '錯誤: {message}',
  'label.shipper_address_book.title': '寄件人地址簿',
  'label.receiver_address_book.title': '收件人地址簿',
  'label.package.quantity.tooltip': '數量',
  'label.require_return_label': '要求創建退回運單',
  'label.return_service_code': '退回服務渠道代碼',
  'label.message.return_service_code': '退回服務渠道代碼',
  'label.title.return_infomartion': '退回服務基本信息',
  'label.service_code': '服務渠道代碼',
  'label.message.service_code': '請選擇服務渠道代碼',
  'label.wms_outbound': '從 W/H 出貨',
  'label.upload.file': '上傳檔案',
  'label.message.upload_file': '請選擇上傳檔案！ ',
  'label.button.uploading': '上傳中',
  'label.button.start-upload': '開始上傳',
  'label.button.start-upload-one-sku-order': '開始上傳 (單品)',
  'label.select-file': '選擇檔案',
  'label.select-here-download-template-1': '點選 ',
  'label.select-here-download-template-2': '此處',
  'label.select-here-download-template-3': ' 下載檔案模板',
  'label.upload-to-create': '上傳創建',
  'label.message.pls-add-product-first': '請先添加產品',
  'label.add-new-package-button': '添加新包裹',
  'label.add-new-package-item-button': '添加包裹產品',
  'label.upload.tab.upload_one_sku': '單品訂單上傳',
  'label.upload.tab.upload_one_sku_tooltip': '單品訂單上傳',
  'label.upload.tab.upload_multi_sku': '多品訂單上傳',
  'label.upload.tab.upload_multi_sku_tooltip': '多品訂單上傳',
  'label.upload.tab.upload_order_tooltip': '訂單上傳',
};
